module.exports = "<div class=\"slidecontainer\">\r\n  <span class=\"min-max-text text-left\">{{min}}</span>\r\n  <input\r\n    type=\"range\"\r\n    [min]=\"min\"\r\n    [max]=\"max\"\r\n    [(ngModel)]=\"value\"\r\n    (ngModelChange)=\"valueChange.emit($event)\"\r\n    class=\"slider\"\r\n  >\r\n  <span class=\"min-max-text text-right\">{{max}}</span>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// G:/UTL/Student/Student-ANG/src/app/shared/range-slider/range-slider.component.html
// module id = ../../../../../src/app/shared/range-slider/range-slider.component.html
// module chunks = main